(() => {
  if (window.__reverieSwatchesLoaded) return;
  window.__reverieSwatchesLoaded = true;

  const STORAGE_KEY = 'reverie_inquiry_basket_v1';
  const STORAGE_VERSION = 1;
  const DEFAULT_STORAGE_DAYS = 365;
  const DEFAULT_STORAGE_MAXIMUM = 100;
  const productCache = new Map();
  const STORAGE_PENDING_REMOVAL_KEY = 'reverie_inquiry_basket_pending_removal_v1';

  const COUNTRY_DIAL_CODES = {
    "afghanistan": "+93",
    "aland": "+358",
    "alandislands": "+358",
    "albania": "+355",
    "algeria": "+213",
    "americansamoa": "+1684",
    "andorra": "+376",
    "angola": "+244",
    "anguilla": "+1264",
    "antiguaandbarbuda": "+1268",
    "argentina": "+54",
    "armenia": "+374",
    "aruba": "+297",
    "australia": "+61",
    "austria": "+43",
    "azerbaijan": "+994",
    "bahamas": "+1242",
    "bahrain": "+973",
    "bangladesh": "+880",
    "barbados": "+1246",
    "belarus": "+375",
    "belgium": "+32",
    "belize": "+501",
    "benin": "+229",
    "bermuda": "+1441",
    "bhutan": "+975",
    "bolivia": "+591",
    "boliviaplurinationalstateof": "+591",
    "bonairesinteustatiusandsaba": "+599",
    "bosniaandherzegovina": "+387",
    "botswana": "+267",
    "brazil": "+55",
    "britishindianoceanterritory": "+246",
    "britishvirginislands": "+1284",
    "brunei": "+673",
    "bruneidarussalam": "+673",
    "bulgaria": "+359",
    "burkinafaso": "+226",
    "burundi": "+257",
    "caboverde": "+238",
    "cambodia": "+855",
    "cameroon": "+237",
    "canada": "+1",
    "capeverde": "+238",
    "caribbeannetherlands": "+599",
    "caymanislands": "+1345",
    "centralafricanrepublic": "+236",
    "chad": "+235",
    "chile": "+56",
    "china": "+86",
    "christmasisland": "+61",
    "cocosislands": "+61",
    "cocoskeelingislands": "+61",
    "colombia": "+57",
    "comoros": "+269",
    "congobrazzaville": "+242",
    "congokinshasa": "+243",
    "congorepublic": "+242",
    "cookislands": "+682",
    "costarica": "+506",
    "cotedivoire": "+225",
    "croatia": "+385",
    "cuba": "+53",
    "curacao": "+599",
    "cyprus": "+357",
    "czechia": "+420",
    "czechrepublic": "+420",
    "democraticrepublicofthecongo": "+243",
    "denmark": "+45",
    "djibouti": "+253",
    "dominica": "+1767",
    "dominicanrepublic": "+1809",
    "easttimor": "+670",
    "ecuador": "+593",
    "egypt": "+20",
    "elsalvador": "+503",
    "equatorialguinea": "+240",
    "eritrea": "+291",
    "estonia": "+372",
    "eswatini": "+268",
    "ethiopia": "+251",
    "falklandislands": "+500",
    "faroeislands": "+298",
    "fiji": "+679",
    "finland": "+358",
    "france": "+33",
    "frenchguiana": "+594",
    "frenchpolynesia": "+689",
    "frenchsouthernterritories": "+262",
    "gabon": "+241",
    "gambia": "+220",
    "georgia": "+995",
    "germany": "+49",
    "ghana": "+233",
    "gibraltar": "+350",
    "greece": "+30",
    "greenland": "+299",
    "grenada": "+1473",
    "guadeloupe": "+590",
    "guam": "+1671",
    "guatemala": "+502",
    "guernsey": "+44",
    "guinea": "+224",
    "guineabissau": "+245",
    "guyana": "+592",
    "haiti": "+509",
    "holysee": "+39",
    "honduras": "+504",
    "hongkong": "+852",
    "hongkongsarchina": "+852",
    "hungary": "+36",
    "iceland": "+354",
    "india": "+91",
    "indonesia": "+62",
    "iran": "+98",
    "iranislamicrepublicof": "+98",
    "iraq": "+964",
    "ireland": "+353",
    "isleofman": "+44",
    "israel": "+972",
    "italy": "+39",
    "jamaica": "+1876",
    "japan": "+81",
    "jersey": "+44",
    "jordan": "+962",
    "kazakhstan": "+7",
    "kenya": "+254",
    "kiribati": "+686",
    "koreademocraticpeoplesrepublicof": "+850",
    "korearepublicof": "+82",
    "kosovo": "+383",
    "kuwait": "+965",
    "kyrgyzstan": "+996",
    "laopeoplesdemocraticrepublic": "+856",
    "laos": "+856",
    "latvia": "+371",
    "lebanon": "+961",
    "lesotho": "+266",
    "liberia": "+231",
    "libya": "+218",
    "liechtenstein": "+423",
    "lithuania": "+370",
    "luxembourg": "+352",
    "macao": "+853",
    "macaosarchina": "+853",
    "macau": "+853",
    "madagascar": "+261",
    "malawi": "+265",
    "malaysia": "+60",
    "maldives": "+960",
    "mali": "+223",
    "malta": "+356",
    "martinique": "+596",
    "mauritania": "+222",
    "mauritius": "+230",
    "mayotte": "+262",
    "mexico": "+52",
    "micronesia": "+691",
    "moldova": "+373",
    "moldovarepublicof": "+373",
    "monaco": "+377",
    "mongolia": "+976",
    "montenegro": "+382",
    "montserrat": "+1664",
    "morocco": "+212",
    "mozambique": "+258",
    "myanmar": "+95",
    "myanmarburma": "+95",
    "namibia": "+264",
    "nauru": "+674",
    "nepal": "+977",
    "netherlands": "+31",
    "newcaledonia": "+687",
    "newzealand": "+64",
    "nicaragua": "+505",
    "niger": "+227",
    "nigeria": "+234",
    "niue": "+683",
    "norfolkisland": "+672",
    "northernmarianaislands": "+1670",
    "northkorea": "+850",
    "northmacedonia": "+389",
    "norway": "+47",
    "oman": "+968",
    "pakistan": "+92",
    "palau": "+680",
    "palestine": "+970",
    "palestinianterritories": "+970",
    "panama": "+507",
    "papuanewguinea": "+675",
    "paraguay": "+595",
    "peru": "+51",
    "philippines": "+63",
    "pitcairnislands": "+64",
    "poland": "+48",
    "portugal": "+351",
    "puertorico": "+1787",
    "qatar": "+974",
    "reunion": "+262",
    "romania": "+40",
    "russia": "+7",
    "russianfederation": "+7",
    "rwanda": "+250",
    "saintbarthelemy": "+590",
    "saintkittsandnevis": "+1869",
    "saintlucia": "+1758",
    "saintmaarten": "+1721",
    "saintmartin": "+590",
    "saintpierreandmiquelon": "+508",
    "saintvincentandthegrenadines": "+1784",
    "samoa": "+685",
    "sanmarino": "+378",
    "saotomeandprincipe": "+239",
    "saudiarabia": "+966",
    "senegal": "+221",
    "serbia": "+381",
    "seychelles": "+248",
    "sierraleone": "+232",
    "singapore": "+65",
    "sintmaarten": "+1721",
    "slovakia": "+421",
    "slovenia": "+386",
    "solomonislands": "+677",
    "somalia": "+252",
    "southafrica": "+27",
    "southgeorgiaandsouthsandwichislands": "+500",
    "southkorea": "+82",
    "southsudan": "+211",
    "spain": "+34",
    "srilanka": "+94",
    "stbarthelemy": "+590",
    "sthelena": "+290",
    "stkittsandnevis": "+1869",
    "stlucia": "+1758",
    "stmartin": "+590",
    "stpierreandmiquelon": "+508",
    "stvincentandgrenadines": "+1784",
    "sudan": "+249",
    "suriname": "+597",
    "svalbardandjanmayen": "+47",
    "swaziland": "+268",
    "sweden": "+46",
    "switzerland": "+41",
    "syria": "+963",
    "syrianarabrepublic": "+963",
    "taiwan": "+886",
    "taiwanprovinceofchina": "+886",
    "tajikistan": "+992",
    "tanzania": "+255",
    "tanzaniaunitedrepublicof": "+255",
    "thailand": "+66",
    "timorleste": "+670",
    "togo": "+228",
    "tokelau": "+690",
    "tonga": "+676",
    "trinidadandtobago": "+1868",
    "tunisia": "+216",
    "turkey": "+90",
    "turkmenistan": "+993",
    "turksandcaicosislands": "+1649",
    "tuvalu": "+688",
    "uganda": "+256",
    "ukraine": "+380",
    "unitedarabemirates": "+971",
    "unitedkingdom": "+44",
    "unitedstates": "+1",
    "uruguay": "+598",
    "usoutlyingislands": "+1",
    "usvirginislands": "+1340",
    "uzbekistan": "+998",
    "vanuatu": "+678",
    "vatican": "+39",
    "vaticancity": "+39",
    "venezuela": "+58",
    "vietnam": "+84",
    "virginislandsbritish": "+1284",
    "virginislandsus": "+1340",
    "wallisandfutuna": "+681",
    "westernsahara": "+212",
    "yemen": "+967",
    "zambia": "+260",
    "zimbabwe": "+263",
    "antarctica": "+672",
    "bouvetisland": "+47",
    "congo": "+242",
    "congothedemocraticrepublicofthe": "+243",
    "heardislandandmcdonaldislands": "+672",
    "marshallislands": "+692",
    "micronesiafederatedstatesof": "+691",
    "palestinestateof": "+970",
    "pitcairn": "+64",
    "saintmartinfrenchpart": "+590",
    "sintmaartendutchpart": "+1721",
    "sainthelenaascensionandtristandacunha": "+290",
    "sthelenaascensionandtristandacunha": "+290",
    "unitedstatesminoroutlyingislands": "+1",
    "venezuelabolivarianrepublicof": "+58",
  };

  const normalizeCountryKey = (value) =>
    String(value || '')
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .toLowerCase()
      .replace(/&/g, 'and')
      .replace(/[^a-z0-9]+/g, '');

  const dialCodeForCountry = (countryText) =>
    COUNTRY_DIAL_CODES[normalizeCountryKey(countryText)] || '';
  const ISO_COUNTRY_CODES = 'AF AX AL DZ AS AD AO AI AQ AG AR AM AW AU AT AZ BS BH BD BB BY BE BZ BJ BM BT BO BQ BA BW BV BR IO BN BG BF BI CV KH CM CA KY CF TD CL CN CX CC CO KM CG CD CK CR CI HR CU CW CY CZ DK DJ DM DO EC EG SV GQ ER EE SZ ET FK FO FJ FI FR GF PF TF GA GM GE DE GH GI GR GL GD GP GU GT GG GN GW GY HT HM VA HN HK HU IS IN ID IR IQ IE IM IL IT JM JP JE JO KZ KE KI KP KR KW KG LA LV LB LS LR LY LI LT LU MO MG MW MY MV ML MT MH MQ MR MU YT MX FM MD MC MN ME MS MA MZ MM NA NR NP NL NC NZ NI NE NG NU NF MK MP NO OM PK PW PS PA PG PY PE PH PN PL PT PR QA RE RO RU RW BL SH KN LC MF PM VC WS SM ST SA SN RS SC SL SG SX SK SI SB SO ZA GS SS ES LK SD SR SJ SE CH SY TW TJ TZ TH TL TG TK TO TT TN TR TM TC TV UG UA AE GB US UM UY UZ VU VE VN VG VI WF EH YE ZM ZW XK'.split(' ');
  const COUNTRY_ISO_ALIASES = {
    aland: 'AX',
    alandislands: 'AX',
    boliviaplurinationalstateof: 'BO',
    bonairesinteustatiusandsaba: 'BQ',
    bruneidarussalam: 'BN',
    caribbeannetherlands: 'BQ',
    cocosislands: 'CC',
    congobrazzaville: 'CG',
    congokinshasa: 'CD',
    congorepublic: 'CG',
    congothedemocraticrepublicofthe: 'CD',
    cotedivoire: 'CI',
    democraticrepublicofthecongo: 'CD',
    holysee: 'VA',
    hongkongsarchina: 'HK',
    iranislamicrepublicof: 'IR',
    koreademocraticpeoplesrepublicof: 'KP',
    korearepublicof: 'KR',
    laopeoplesdemocraticrepublic: 'LA',
    macaosarchina: 'MO',
    micronesiafederatedstatesof: 'FM',
    moldovarepublicof: 'MD',
    palestinestateof: 'PS',
    pitcairnislands: 'PN',
    russia: 'RU',
    russianfederation: 'RU',
    sainthelenaascensionandtristandacunha: 'SH',
    saintmartinfrenchpart: 'MF',
    sintmaartendutchpart: 'SX',
    southkorea: 'KR',
    northkorea: 'KP',
    syrianarabrepublic: 'SY',
    taiwanprovinceofchina: 'TW',
    tanzaniaunitedrepublicof: 'TZ',
    unitedstatesminoroutlyingislands: 'UM',
    usoutlyingislands: 'UM',
    venezuelabolivarianrepublicof: 'VE',
    virginislandsbritish: 'VG',
    virginislandsus: 'VI',
  };
  const COUNTRY_ISO_BY_KEY = new Map(Object.entries(COUNTRY_ISO_ALIASES));
  const countryDisplayNameProviders = [];
  if (typeof Intl.DisplayNames === 'function') {
    try {
      countryDisplayNameProviders.push(new Intl.DisplayNames(['en'], { type: 'region' }));
      const pageLanguage = document.documentElement.lang || navigator.language || 'en';
      if (!pageLanguage.toLowerCase().startsWith('en')) {
        countryDisplayNameProviders.push(new Intl.DisplayNames([pageLanguage], { type: 'region' }));
      }
    } catch (_error) {
      countryDisplayNameProviders.length = 0;
    }
  }
  ISO_COUNTRY_CODES.forEach((iso) => {
    COUNTRY_ISO_BY_KEY.set(normalizeCountryKey(iso), iso);
    countryDisplayNameProviders.forEach((provider) => {
      const name = provider.of(iso);
      if (name && name !== iso) COUNTRY_ISO_BY_KEY.set(normalizeCountryKey(name), iso);
    });
  });
  const isoForCountry = (countryText) => COUNTRY_ISO_BY_KEY.get(normalizeCountryKey(countryText)) || '';
  const flagForIso = (iso) =>
    /^[A-Z]{2}$/.test(iso)
      ? String.fromCodePoint(...iso.split('').map((letter) => letter.charCodeAt(0) + 127397))
      : '';
  const countryMetaForName = (countryText) => {
    const iso = isoForCountry(countryText);
    return {
      name: String(countryText || '').trim(),
      iso,
      flag: flagForIso(iso),
      dial: dialCodeForCountry(countryText),
    };
  };
  const DIAL_CODE_VALUES = Object.values(COUNTRY_DIAL_CODES)
    .filter((value, index, all) => all.indexOf(value) === index)
    .sort((a, b) => b.length - a.length);

  const detectDialCodeIn = (input) => {
    const text = String(input || '').trim();
    for (const code of DIAL_CODE_VALUES) {
      if (text.startsWith(`${code} `)) return code;
    }
    return '';
  };

  const formatLocalDate = (date) => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  };

  const escapeCsvValue = (value) => {
    const text = String(value || '');
    return /[",\r\n]/.test(text) ? `"${text.replace(/"/g, '""')}"` : text;
  };

  const readPendingRemoval = () => {
    try {
      const stored = JSON.parse(window.localStorage.getItem(STORAGE_PENDING_REMOVAL_KEY) || 'null');
      if (!Array.isArray(stored)) return [];
      return stored.map((key) => textValue(key, 120)).filter(Boolean);
    } catch (_error) {
      return [];
    }
  };

  const writePendingRemoval = (keys) => {
    try {
      window.localStorage.setItem(STORAGE_PENDING_REMOVAL_KEY, JSON.stringify(Array.from(keys)));
    } catch (_error) {
      // Best-effort; the basket itself remains available in this session.
    }
  };

  const clearPendingRemoval = () => {
    try {
      window.localStorage.removeItem(STORAGE_PENDING_REMOVAL_KEY);
    } catch (_error) {
      // Best-effort.
    }
  };

  const textValue = (value, maximum = 500) => String(value || '').trim().slice(0, maximum);

  const safeUrl = (value) => {
    if (!value) return '';

    try {
      const url = new URL(String(value), window.location.origin);
      return url.protocol === 'http:' || url.protocol === 'https:' ? url.href : '';
    } catch (_error) {
      return '';
    }
  };

  const imageUrl = (value) => {
    if (!value) return '';
    if (typeof value === 'string') return safeUrl(value);
    return safeUrl(value.url || value.src || value.originalSrc || value.original_url);
  };

  const normalizeStoredItem = (item) => {
    if (!item || typeof item !== 'object') return null;

    const productId = textValue(item.productId, 40);
    const variantId = textValue(item.variantId, 40);
    const productTitle = textValue(item.productTitle, 240);
    if (!productId || !variantId || !productTitle) return null;

    return {
      productId,
      variantId,
      productTitle,
      variantTitle: textValue(item.variantTitle, 240),
      sku: textValue(item.sku, 120),
      url: safeUrl(item.url),
      imageUrl: safeUrl(item.imageUrl),
      addedAt: Number.isFinite(Number(item.addedAt)) ? Number(item.addedAt) : Date.now(),
    };
  };

  const itemKey = (item) => `${item.productId}:${item.variantId}`;

  const readStoredBasket = (maximum = DEFAULT_STORAGE_MAXIMUM) => {
    try {
      const stored = JSON.parse(window.localStorage.getItem(STORAGE_KEY) || 'null');
      if (!stored || stored.version !== STORAGE_VERSION || !Array.isArray(stored.items)) return [];
      if (Number(stored.expiresAt) <= Date.now()) {
        window.localStorage.removeItem(STORAGE_KEY);
        return [];
      }
      return stored.items.map(normalizeStoredItem).filter(Boolean).slice(0, maximum);
    } catch (_error) {
      return [];
    }
  };

  const writeStoredBasket = (items, storageDays = DEFAULT_STORAGE_DAYS) => {
    const now = Date.now();
    window.localStorage.setItem(
      STORAGE_KEY,
      JSON.stringify({
        version: STORAGE_VERSION,
        updatedAt: now,
        expiresAt: now + storageDays * 24 * 60 * 60 * 1000,
        items,
      }),
    );
  };

  const fetchProductData = async (productUrl) => {
    const safeProductUrl = safeUrl(productUrl);
    if (!safeProductUrl) throw new Error('Invalid product URL');
    if (productCache.has(safeProductUrl)) return productCache.get(safeProductUrl);

    const url = new URL(safeProductUrl);
    if (!url.pathname.includes('/products/')) throw new Error('Invalid product path');
    url.pathname = `${url.pathname.replace(/\/$/, '')}.js`;
    url.search = '';

    const request = fetch(url.href, { headers: { Accept: 'application/json' } }).then((response) => {
      if (!response.ok) throw new Error('Product request failed');
      return response.json();
    });
    productCache.set(safeProductUrl, request);
    return request;
  };

  const productItem = (product, variant, fallbackImage, fallbackUrl) => {
    const productId = textValue(product?.id, 40);
    const variantId = textValue(variant?.id, 40);
    const productTitle = textValue(product?.title, 240);
    if (!productId || !variantId || !productTitle) return null;

    const productUrl = new URL(safeUrl(fallbackUrl || product.url) || window.location.origin);
    productUrl.searchParams.set('variant', variantId);
    const variantTitle = textValue(variant.title, 240);

    return {
      productId,
      variantId,
      productTitle,
      variantTitle: variantTitle === 'Default Title' ? '' : variantTitle,
      sku: textValue(variant.sku, 120),
      url: safeUrl(productUrl.href),
      imageUrl:
        imageUrl(variant.featured_image) ||
        imageUrl(product.featured_image) ||
        imageUrl(product.images?.[0]) ||
        imageUrl(fallbackImage),
      addedAt: Date.now(),
    };
  };

  const selectedVariantIdFromProductInfo = (productInfo) => {
    if (!productInfo) return '';

    try {
      const variantData = JSON.parse(
        productInfo.querySelector('variant-selects [data-selected-variant]')?.textContent || '{}',
      );
      return textValue(variantData?.id, 40);
    } catch (_error) {
      return '';
    }
  };

  const applyInquiryButtonState = (button, active) => {
    const textSpan = button.querySelector('.reverie-inquiry-button-text');
    const unit = button.querySelector('[data-reverie-inquiry-unit]');
    if (textSpan) {
      if (!textSpan.dataset.originalText) textSpan.dataset.originalText = textSpan.textContent;
      textSpan.textContent = active
        ? button.dataset.removeLabel || 'Remove from inquiry basket'
        : textSpan.dataset.originalText;
    }
    if (unit) unit.textContent = active ? '1' : unit.dataset.defaultValue || '+1';
    button.setAttribute(
      'aria-label',
      active
        ? button.dataset.removeAriaLabel || button.dataset.removeLabel || 'Remove from inquiry basket'
        : button.dataset.addAriaLabel || 'Add to inquiry basket',
    );
    if (active) {
      button.dataset.reverieInquiryActive = 'true';
      button.setAttribute('aria-pressed', 'true');
    } else {
      delete button.dataset.reverieInquiryActive;
      button.setAttribute('aria-pressed', 'false');
    }
  };

  const buttonItemKey = (button, variantId) => {
    const baseUrl = safeUrl(button.dataset.productUrl);
    if (!baseUrl || !variantId) return '';
    try {
      const url = new URL(baseUrl);
      url.searchParams.set('variant', String(variantId));
      return safeUrl(url.href);
    } catch (_error) {
      return '';
    }
  };

  const currentVariantIdForButton = (button) => {
    const productInfo = button.closest('product-info');
    return (
      productInfo?.querySelector('form[action*="/cart/add"] [name="id"]')?.value ||
      productInfo?.querySelector('[name="id"]')?.value ||
      selectedVariantIdFromProductInfo(productInfo) ||
      new URL(window.location.href).searchParams.get('variant') ||
      button.dataset.variantId ||
      ''
    );
  };

  const refreshInquiryButtonState = (button) => {
    if (!button || button.dataset.reverieInquiryInitialized !== 'true') return;
    const storageMaximum = Math.max(
      1,
      Number.parseInt(button.dataset.storageMaximum || DEFAULT_STORAGE_MAXIMUM, 10) ||
        DEFAULT_STORAGE_MAXIMUM,
    );
    const key = buttonItemKey(button, currentVariantIdForButton(button));
    const active = Boolean(key) && readStoredBasket(storageMaximum).some((item) => item.url === key);
    applyInquiryButtonState(button, active);
  };

  const initializeInquiryAddButton = (button) => {
    if (!button || button.dataset.reverieInquiryInitialized === 'true') return;
    button.dataset.reverieInquiryInitialized = 'true';

    const status = button.parentElement?.querySelector('[data-reverie-inquiry-status]');
    const storageDays = Math.max(
      1,
      Number.parseInt(button.dataset.storageDays || DEFAULT_STORAGE_DAYS, 10) || DEFAULT_STORAGE_DAYS,
    );
    const storageMaximum = Math.max(
      1,
      Number.parseInt(button.dataset.storageMaximum || DEFAULT_STORAGE_MAXIMUM, 10) ||
        DEFAULT_STORAGE_MAXIMUM,
    );

    const announce = (message) => {
      if (status) status.textContent = message || '';
    };

    const isActive = () => {
      const key = buttonItemKey(button, currentVariantIdForButton(button));
      return Boolean(key) && readStoredBasket(storageMaximum).some((item) => item.url === key);
    };

    const removeActiveItem = () => {
      const key = buttonItemKey(button, currentVariantIdForButton(button));
      const items = readStoredBasket(storageMaximum);
      const nextItems = key ? items.filter((item) => item.url !== key) : items;
      if (nextItems.length === items.length) return;
      writeStoredBasket(nextItems, storageDays);
      applyInquiryButtonState(button, false);
      announce(button.dataset.removedLabel || button.dataset.removeLabel || 'Removed from your inquiry basket.');
      window.dispatchEvent(
        new CustomEvent('reverie:inquiry-basket-change', {
          detail: { count: nextItems.length, items: nextItems },
        }),
      );
    };

    button.addEventListener('click', async () => {
      if (button.dataset.reverieInquiryActive === 'true') {
        removeActiveItem();
        return;
      }

      button.disabled = true;
      button.setAttribute('aria-busy', 'true');
      announce(button.dataset.loadingLabel);

      try {
        const product = await fetchProductData(button.dataset.productUrl);
        const selectedVariantId = currentVariantIdForButton(button);
        const variants = Array.isArray(product.variants) ? product.variants : [];
        const variant =
          variants.find((candidate) => String(candidate.id) === String(selectedVariantId)) || variants[0];
        const item = productItem(product, variant, button.dataset.imageUrl, button.dataset.productUrl);
        if (!item) throw new Error('Invalid inquiry product');

        const items = readStoredBasket(storageMaximum);
        if (items.some((candidate) => itemKey(candidate) === itemKey(item))) {
          applyInquiryButtonState(button, true);
          announce(button.dataset.duplicateLabel);
          return;
        }
        if (items.length >= storageMaximum) {
          announce(button.dataset.limitLabel);
          return;
        }

        const nextItems = [...items, item];
        writeStoredBasket(nextItems, storageDays);
        applyInquiryButtonState(button, true);
        announce(
          (button.dataset.addedLabel || 'Added to your inquiry basket.').replace(
            '[count]',
            String(nextItems.length),
          ),
        );
        window.dispatchEvent(
          new CustomEvent('reverie:inquiry-basket-change', {
            detail: { count: nextItems.length, items: nextItems },
          }),
        );
      } catch (_error) {
        announce(button.dataset.errorLabel);
      } finally {
        button.disabled = false;
        button.removeAttribute('aria-busy');
      }
    });

    const productInfo = button.closest('product-info');
    const variantSelects = productInfo?.querySelector('variant-selects');
    if (variantSelects) {
      const sync = () => applyInquiryButtonState(button, isActive());
      variantSelects.addEventListener('variant:change', sync);
      variantSelects.addEventListener('change', sync);
    }

    applyInquiryButtonState(button, isActive());
  };



  const initializeWorkbench = (root) => {
    if (!root || root.dataset.swatchesInitialized === 'true') return;
    root.dataset.swatchesInitialized = 'true';

    const form = root.querySelector('form');
    if (!form) return;

    const fabricInputs = Array.from(root.querySelectorAll('[data-swatches-fabric]'));
    const serviceInputs = Array.from(root.querySelectorAll('[data-swatches-service]'));
    const pathInputs = Array.from(root.querySelectorAll('[data-swatches-path]'));
    const unsureFabric = root.querySelector('[data-swatches-unsure-fabric]');
    const unsurePath = root.querySelector('[data-swatches-unsure-path]');
    const fabricOutput = root.querySelector('[data-swatches-fabric-output]');
    const serviceOutput = root.querySelector('[data-swatches-service-output]');
    const productOutput = root.querySelector('[data-swatches-product-output]');
    const productJsonOutput = root.querySelector('[data-swatches-product-json-output]');
    const fabricCounts = Array.from(root.querySelectorAll('[data-swatches-count]'));
    const collectionCount = root.querySelector('[data-swatches-collection-count]');
    const clearButton = root.querySelector('[data-swatches-clear]');
    const fabricError = root.querySelector('[data-swatches-fabric-error]');
    const summaryFields = Array.from(root.querySelectorAll('[data-swatches-summary]'));
    const summarySources = Array.from(root.querySelectorAll('[data-swatches-summary-source]'));
    const summaryPanel = root.querySelector('[data-swatches-summary-panel]');
    const collectionPanel = root.querySelector('[data-swatches-collection-panel]');
    const customRequest = root.querySelector('[data-swatches-custom-request]');
    const productPicker = root.querySelector('[data-swatches-product-picker]');
    const productSearch = root.querySelector('[data-swatches-product-search]');
    const productSearchButton = root.querySelector('[data-swatches-product-search-button]');
    const productStatus = root.querySelector('[data-swatches-product-status]');
    const productResults = root.querySelector('[data-swatches-product-results]');
    const productList = root.querySelector('[data-swatches-product-list]');
    const productEmpty = root.querySelector('[data-swatches-product-empty]');
    const productCount = root.querySelector('[data-swatches-product-count]');
    const productClear = root.querySelector('[data-swatches-product-clear]');
    const requestTypeInputs = Array.from(root.querySelectorAll('[data-swatches-request-type]'));
    const requestCustomInput = root.querySelector('[data-swatches-request-custom]');
    const basketMeta = root.querySelector('[data-swatches-basket-meta]');
    const selectAll = root.querySelector('[data-swatches-basket-select-all]');
    const basketSelected = root.querySelector('[data-swatches-basket-selected]');
    const basketStatus = root.querySelector('[data-swatches-basket-status]');
    const exportCopy = root.querySelector('[data-swatches-export-copy]');
    const exportCsv = root.querySelector('[data-swatches-export-csv]');
    const exportPrint = root.querySelector('[data-swatches-export-print]');
    const basketSheet = root.querySelector('[data-swatches-basket-sheet]');
    const basketSheetClose = root.querySelector('[data-swatches-basket-sheet-close]');
    const floatingEntry = root.querySelector('[data-swatches-floating-entry]');
    const floatingCount = root.querySelector('[data-swatches-floating-count]');
    const printBook = root.querySelector('[data-swatches-print-book]');
    const successRemaining = root.querySelector('[data-swatches-success-remaining]');
    const countrySelect = root.querySelector('[data-swatches-summary-source="country"]');
    const whatsappInput = root.querySelector('[data-swatches-whatsapp]');
    const dialPrefix = root.querySelector('[data-swatches-dial]');
    const dialCodeLabel = root.querySelector('[data-swatches-dial-code]');
    const dialFlag = root.querySelector('[data-swatches-dial-flag]');
    const dialPlaceholder = root.querySelector('[data-swatches-dial-placeholder]');
    const dialHint = root.querySelector('[data-swatches-dial-hint]');
    const pickerSelects = Array.from(root.querySelectorAll('[data-swatches-picker]'));
    const wizard = root.querySelector('[data-swatches-wizard]');
    const wizardSteps = Array.from(root.querySelectorAll('[data-swatches-wizard-step]'));
    // Derived from the markup so the wizard keeps working if the stages are regrouped again.
    const stepNumberOf = (selector) => {
      const owner = root.querySelector(selector)?.closest('[data-swatches-wizard-step]');
      return Number.parseInt(owner?.dataset.swatchesWizardStep || '0', 10) || 0;
    };
    const FABRIC_STEP = stepNumberOf('[data-swatches-fabric-group]') || 2;
    const CONTACT_STEP = stepNumberOf('[name="contact[email]"]') || 3;
    const wizardGoButtons = Array.from(root.querySelectorAll('[data-swatches-wizard-go]'));
    const wizardProgressButtons = Array.from(
      root.querySelectorAll('.reverie-swatches-wizard__progress [data-swatches-wizard-go]'),
    );
    const wizardBack = root.querySelector('[data-swatches-wizard-back]');
    const wizardNext = root.querySelector('[data-swatches-wizard-next]');
    const wizardMeter = root.querySelector('[data-swatches-wizard-meter]');
    const wizardPosition = root.querySelector('[data-swatches-wizard-position]');
    const wizardCurrentTitle = root.querySelector('[data-swatches-wizard-current-title]');
    const wizardNavigationStatus = root.querySelector('[data-swatches-wizard-navigation-status]');
    const wizardLive = root.querySelector('[data-swatches-wizard-live]');
    const wizardReviewValues = Array.from(root.querySelectorAll('[data-swatches-wizard-review-value]'));
    const restoreCheckedFromPending = root.querySelector('.reverie-swatches-form__error-summary') !== null;
    const compactSummaryQuery = window.matchMedia('(max-width: 749px)');
    const countSuffix = fabricCounts[0] ? fabricCounts[0].textContent.replace(/^\s*\d+\s*/, '').trim() : '';
    const collectionSuffix = collectionCount
      ? collectionCount.textContent.replace(/^\s*\d+\s*/, '').trim()
      : countSuffix;
    const storageDays = Math.max(
      1,
      Number.parseInt(productPicker?.dataset.storageDays || DEFAULT_STORAGE_DAYS, 10) || DEFAULT_STORAGE_DAYS,
    );
    const storageMaximum = Math.max(
      1,
      Number.parseInt(productPicker?.dataset.storageMaximum || DEFAULT_STORAGE_MAXIMUM, 10) ||
        DEFAULT_STORAGE_MAXIMUM,
    );
    let basketItems = [];
    let selectedKeys = new Set();
    let searchTimer;
    let activeSearch;
    let lastDialCode = '';
    let lastDialCountry = '';
    let currentWizardStep = 1;
    let highestWizardStep = 1;
    const enhancedSelects = new Map();

    const updateSummaryMode = (query) => {
      if (summaryPanel) summaryPanel.open = !query.matches;
      if (collectionPanel) collectionPanel.open = wizard ? false : !query.matches;
    };

    updateSummaryMode(compactSummaryQuery);
    if (compactSummaryQuery.addEventListener) {
      compactSummaryQuery.addEventListener('change', updateSummaryMode);
    } else {
      compactSummaryQuery.addListener(updateSummaryMode);
    }

    summaryFields.forEach((field) => {
      field.dataset.emptyText = field.textContent.trim();
    });

    const selectedText = (source) => {
      if (source instanceof HTMLSelectElement) {
        return source.value ? source.options[source.selectedIndex]?.text.trim() || source.value : '';
      }
      return source.value.trim();
    };

    const setSummary = (name, value) => {
      const target = root.querySelector(`[data-swatches-summary="${name}"]`);
      if (!target) return;
      target.textContent = value || target.dataset.emptyText || '';
    };

    const setProductStatus = (message) => {
      if (productStatus) productStatus.textContent = message || '';
    };

    let pickerDialog;
    let pickerTitle;
    let pickerSearch;
    let pickerList;
    let pickerEmpty;
    let activePickerItems = [];
    let activePickerSelect;
    let activePickerTrigger;
    let activePickerMode = '';
    let pickerNextFocus;

    const setDialTrigger = (meta = {}) => {
      const code = meta.dial || '';
      const flag = meta.flag || '';
      const name = meta.name || '';
      if (dialCodeLabel) dialCodeLabel.textContent = code || '+';
      if (dialFlag) {
        dialFlag.textContent = flag;
        dialFlag.hidden = !flag;
      }
      if (dialPlaceholder) dialPlaceholder.hidden = Boolean(flag);
      if (dialPrefix) {
        const heading = root.dataset.pickerPhoneHeading || 'Select WhatsApp country code';
        dialPrefix.setAttribute('aria-label', name ? `${heading}: ${name} ${code}` : heading);
      }
    };

    const syncEnhancedSelect = (select) => {
      const enhanced = enhancedSelects.get(select);
      if (!enhanced) return;
      const option = select.options[select.selectedIndex];
      const label = option?.textContent?.trim() || select.dataset.pickerHeading || '';
      const meta = select.matches('[data-picker-country]') && select.value ? countryMetaForName(label) : null;
      enhanced.label.textContent = label;
      enhanced.flag.textContent = meta?.flag || '';
      enhanced.flag.hidden = !meta?.flag;
      enhanced.code.textContent = meta?.dial || '';
      enhanced.code.hidden = !meta?.dial;
      enhanced.trigger.setAttribute(
        'aria-label',
        `${select.dataset.pickerHeading || 'Select an option'}: ${label}`,
      );
      if (select.validity.valid) enhanced.trigger.removeAttribute('aria-invalid');
    };

    const pickerItemsForSelect = (select) =>
      Array.from(select.options)
        .filter((option) => {
          const name = option.textContent.trim();
          return !option.disabled && name !== '---' && option.value !== '---';
        })
        .map((option) => {
          const name = option.textContent.trim();
          const meta = select.matches('[data-picker-country]') ? countryMetaForName(name) : null;
          return {
            value: option.value,
            name,
            group: option.parentElement instanceof HTMLOptGroupElement ? option.parentElement.label : '',
            iso: meta?.iso || '',
            flag: meta?.flag || '',
            dial: meta?.dial || '',
          };
        });

    const phonePickerItems = () => {
      if (!countrySelect) return [];
      const seen = new Set();
      return Array.from(countrySelect.options)
        .filter((option) => {
          const name = option.textContent.trim();
          return !option.disabled && option.value && name !== '---' && option.value !== '---';
        })
        .map((option) => countryMetaForName(option.textContent.trim()))
        .filter((item) => {
          const key = `${item.iso}|${item.name}|${item.dial}`;
          if (!item.dial || seen.has(key)) return false;
          seen.add(key);
          return true;
        });
    };

    const activePickerValue = () =>
      activePickerMode === 'phone'
        ? `${normalizeCountryKey(lastDialCountry)}|${lastDialCode}`
        : activePickerSelect?.value || '';

    const renderPickerItems = (query = '') => {
      if (!pickerList || !pickerEmpty) return;
      const search = normalizeCountryKey(query);
      const visibleItems = activePickerItems.filter((item) => {
        if (!search) return true;
        return normalizeCountryKey(`${item.name} ${item.group || ''} ${item.dial || ''} ${item.iso || ''}`).includes(search);
      });
      pickerList.replaceChildren();
      pickerEmpty.hidden = visibleItems.length > 0;
      let currentGroup = null;
      let groupList = pickerList;
      const selectedValue = activePickerValue();
      visibleItems.forEach((item) => {
        const groupName = item.group || '';
        if (groupName !== currentGroup) {
          currentGroup = groupName;
          if (groupName) {
            const group = document.createElement('section');
            group.className = 'reverie-swatches-picker__group';
            const heading = document.createElement('h3');
            heading.textContent = groupName;
            group.append(heading);
            groupList = document.createElement('div');
            groupList.className = 'reverie-swatches-picker__group-list';
            group.append(groupList);
            pickerList.append(group);
          } else {
            groupList = pickerList;
          }
        }
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'reverie-swatches-picker__option';
        button.setAttribute('role', 'option');
        const itemValue =
          activePickerMode === 'phone'
            ? `${normalizeCountryKey(item.name)}|${item.dial}`
            : item.value;
        const selected = itemValue === selectedValue;
        button.setAttribute('aria-selected', String(selected));
        if (selected) button.dataset.selected = 'true';
        if (item.flag) {
          const flag = document.createElement('span');
          flag.className = 'reverie-swatches-picker__flag';
          flag.textContent = item.flag;
          flag.setAttribute('aria-hidden', 'true');
          button.append(flag);
        }
        const name = document.createElement('span');
        name.className = 'reverie-swatches-picker__option-name';
        name.textContent = item.name;
        button.append(name);
        if (item.dial) {
          const code = document.createElement('span');
          code.className = 'reverie-swatches-picker__option-code';
          code.textContent = item.dial;
          button.append(code);
        }
        const check = document.createElement('span');
        check.className = 'reverie-swatches-picker__check';
        check.textContent = '✓';
        check.setAttribute('aria-hidden', 'true');
        button.append(check);
        button.addEventListener('click', () => commitPickerItem(item));
        groupList.append(button);
      });
    };

    const createPickerDialog = () => {
      if (pickerDialog) return pickerDialog;
      pickerDialog = document.createElement('dialog');
      pickerDialog.id = `${form.id}-picker`;
      pickerDialog.className = 'reverie-swatches-picker';
      pickerDialog.innerHTML = `
        <div class="reverie-swatches-picker__surface">
          <header class="reverie-swatches-picker__header">
            <h2 id="${pickerDialog.id}-title" tabindex="-1"></h2>
            <button type="button" class="reverie-swatches-picker__close">
              <span></span>
              <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" aria-hidden="true"><path d="m6 6 12 12M18 6 6 18"></path></svg>
            </button>
          </header>
          <label class="reverie-swatches-picker__search">
            <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="11" cy="11" r="7"></circle><path d="m20 20-4-4"></path></svg>
            <input type="search" autocomplete="off">
          </label>
          <div class="reverie-swatches-picker__list" role="listbox"></div>
          <p class="reverie-swatches-picker__empty" hidden></p>
        </div>`;
      pickerDialog.setAttribute('aria-labelledby', `${pickerDialog.id}-title`);
      pickerTitle = pickerDialog.querySelector('h2');
      pickerSearch = pickerDialog.querySelector('input[type="search"]');
      pickerList = pickerDialog.querySelector('[role="listbox"]');
      pickerEmpty = pickerDialog.querySelector('.reverie-swatches-picker__empty');
      const closeButton = pickerDialog.querySelector('.reverie-swatches-picker__close');
      const closeLabel = root.dataset.pickerCloseLabel || 'Close';
      closeButton.querySelector('span').textContent = closeLabel;
      closeButton.setAttribute('aria-label', closeLabel);
      pickerSearch.placeholder = root.dataset.pickerSearchPlaceholder || 'Search options';
      pickerEmpty.textContent = root.dataset.pickerEmptyLabel || 'No matching options';
      closeButton.addEventListener('click', () => pickerDialog.close());
      pickerSearch.addEventListener('input', () => renderPickerItems(pickerSearch.value));
      pickerDialog.addEventListener('click', (event) => {
        if (event.target === pickerDialog) pickerDialog.close();
      });
      pickerDialog.addEventListener('close', () => {
        document.body.classList.remove('reverie-swatches-picker-open');
        activePickerTrigger?.setAttribute('aria-expanded', 'false');
        const focusTarget = pickerNextFocus || activePickerTrigger;
        activePickerItems = [];
        activePickerSelect = null;
        activePickerTrigger = null;
        activePickerMode = '';
        pickerNextFocus = null;
        window.setTimeout(() => focusTarget?.focus({ preventScroll: true }), 0);
      });
      root.append(pickerDialog);
      return pickerDialog;
    };

    const openPicker = ({ select = null, trigger, mode = 'select' }) => {
      const dialog = createPickerDialog();
      activePickerSelect = select;
      activePickerTrigger = trigger;
      activePickerMode = mode;
      activePickerItems = mode === 'phone' ? phonePickerItems() : pickerItemsForSelect(select);
      const heading =
        mode === 'phone'
          ? root.dataset.pickerPhoneHeading || 'Select WhatsApp country code'
          : select?.dataset.pickerHeading || 'Select an option';
      pickerTitle.textContent = heading;
      pickerSearch.value = '';
      pickerSearch.closest('label').hidden = !(mode === 'phone' || select?.matches('[data-picker-country]'));
      trigger.setAttribute('aria-expanded', 'true');
      renderPickerItems();
      if (typeof dialog.showModal !== 'function') {
        trigger.setAttribute('aria-expanded', 'false');
        select?.showPicker?.();
        return;
      }
      document.body.classList.add('reverie-swatches-picker-open');
      dialog.showModal();
      window.setTimeout(() => {
        if (!pickerSearch.closest('label').hidden) pickerSearch.focus();
        else pickerTitle.focus();
      }, 0);
    };

    const applyPhoneDial = (item) => {
      if (!whatsappInput || !item.dial) return;
      const current = whatsappInput.value.trim();
      const previous = lastDialCode || detectDialCodeIn(current);
      if (!current) {
        whatsappInput.value = `${item.dial} `;
      } else if (previous && current.startsWith(previous)) {
        const localNumber = current.slice(previous.length).trim();
        whatsappInput.value = localNumber ? `${item.dial} ${localNumber}` : `${item.dial} `;
      } else if (!current.startsWith('+')) {
        whatsappInput.value = `${item.dial} ${current}`;
      }
      lastDialCode = item.dial;
      lastDialCountry = item.name;
      setDialTrigger(item);
      if (countrySelect && !countrySelect.value) {
        const countryOption = Array.from(countrySelect.options).find((option) => {
          const meta = countryMetaForName(option.textContent.trim());
          return item.iso ? meta.iso === item.iso : normalizeCountryKey(meta.name) === normalizeCountryKey(item.name);
        });
        if (countryOption) {
          countrySelect.value = countryOption.value;
          countrySelect.dispatchEvent(new Event('input', { bubbles: true }));
          countrySelect.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }
      whatsappInput.dispatchEvent(new Event('input', { bubbles: true }));
      pickerNextFocus = whatsappInput;
    };

    const commitPickerItem = (item) => {
      if (activePickerMode === 'phone') {
        applyPhoneDial(item);
      } else if (activePickerSelect) {
        activePickerSelect.value = item.value;
        activePickerSelect.dispatchEvent(new Event('input', { bubbles: true }));
        activePickerSelect.dispatchEvent(new Event('change', { bubbles: true }));
        syncEnhancedSelect(activePickerSelect);
      }
      pickerDialog?.close();
    };

    const initializePickers = () => {
      if (!pickerSelects.length && !dialPrefix) return;
      const dialog = createPickerDialog();
      pickerSelects.forEach((select) => {
        if (enhancedSelects.has(select)) return;
        const trigger = document.createElement('button');
        trigger.type = 'button';
        trigger.className = 'reverie-swatches-picker-trigger';
        trigger.setAttribute('aria-haspopup', 'dialog');
        trigger.setAttribute('aria-expanded', 'false');
        trigger.setAttribute('aria-controls', dialog.id);
        trigger.innerHTML = `
          <span class="reverie-swatches-picker-trigger__flag" aria-hidden="true" hidden></span>
          <span class="reverie-swatches-picker-trigger__label"></span>
          <span class="reverie-swatches-picker-trigger__code" hidden></span>
          <svg viewBox="0 0 12 8" width="12" height="8" fill="none" stroke="currentColor" stroke-width="1.5" aria-hidden="true"><path d="m1 1.5 5 5 5-5"></path></svg>`;
        enhancedSelects.set(select, {
          trigger,
          flag: trigger.querySelector('.reverie-swatches-picker-trigger__flag'),
          label: trigger.querySelector('.reverie-swatches-picker-trigger__label'),
          code: trigger.querySelector('.reverie-swatches-picker-trigger__code'),
        });
        select.classList.add('reverie-swatches-select--enhanced');
        select.tabIndex = -1;
        select.setAttribute('aria-hidden', 'true');
        select.dataset.pickerReady = 'true';
        select.insertAdjacentElement('afterend', trigger);
        trigger.addEventListener('click', () => openPicker({ select, trigger }));
        select.addEventListener('change', () => syncEnhancedSelect(select));
        select.closest('.reverie-swatches-field')?.querySelector(`label[for="${select.id}"]`)?.addEventListener('click', (event) => {
          event.preventDefault();
          trigger.click();
        });
        syncEnhancedSelect(select);
      });
      if (dialPrefix) {
        dialPrefix.setAttribute('aria-controls', dialog.id);
        dialPrefix.addEventListener('click', () => openPicker({ trigger: dialPrefix, mode: 'phone' }));
      }
      root.dataset.pickersReady = 'true';
    };

    const syncWhatsappDial = () => {
      if (!countrySelect || !whatsappInput) return;
      const countryText = countrySelect.value || countrySelect.selectedOptions[0]?.text || '';
      const code = dialCodeForCountry(countryText);
      const meta = countryText ? countryMetaForName(countryText) : {};
      setDialTrigger(meta);
      if (dialHint) {
        if (code) {
          dialHint.textContent = `International dial code: ${code}`;
          dialHint.hidden = false;
        } else {
          dialHint.hidden = true;
        }
      }
      if (!code) {
        lastDialCode = '';
        lastDialCountry = '';
        return;
      }
      const current = whatsappInput.value.trim();
      if (!current) {
        whatsappInput.value = `${code} `;
      } else {
        const previous = lastDialCode || detectDialCodeIn(current);
        if (previous && previous !== code && current.startsWith(previous)) {
          const localNumber = current.slice(previous.length).trim();
          whatsappInput.value = localNumber ? `${code} ${localNumber}` : `${code} `;
        }
      }
      lastDialCode = code;
      lastDialCountry = countryText;
    };

    if (countrySelect && whatsappInput) {
      countrySelect.addEventListener('change', syncWhatsappDial);
      syncWhatsappDial();
    }

    const readBasket = () => {
      return readStoredBasket(storageMaximum);
    };

    const persistBasket = () => {
      try {
        writeStoredBasket(basketItems, storageDays);
      } catch (_error) {
        setProductStatus(productPicker?.dataset.searchError);
      }
    };

    const productLabel = (item) => {
      const variant = item.variantTitle ? ` — ${item.variantTitle}` : '';
      const sku = item.sku ? ` [SKU ${item.sku}]` : '';
      return `${item.productTitle}${variant}${sku}`;
    };

    const checkedItems = () => basketItems.filter((item) => selectedKeys.has(itemKey(item)));

    const productSummary = () => {
      const labels = checkedItems().map(productLabel);
      if (labels.length <= 3) return labels;
      return [...labels.slice(0, 3), `+${labels.length - 3} more`];
    };

    const syncProductOutputs = () => {
      const items = checkedItems();
      if (productOutput) {
        productOutput.value = items
          .map((item, index) => {
            const lines = [`${index + 1}. ${item.productTitle}`];
            if (item.variantTitle) lines.push(`Variant: ${item.variantTitle}`);
            if (item.sku) lines.push(`SKU: ${item.sku}`);
            if (item.url) lines.push(`Product URL: ${item.url}`);
            if (item.imageUrl) lines.push(`Image URL: ${item.imageUrl}`);
            return lines.join('\n');
          })
          .join('\n\n');
      }

      if (productJsonOutput) {
        productJsonOutput.value = JSON.stringify(
          items.map(({ productId, variantId, productTitle, variantTitle, sku, url, imageUrl }) => ({
            productId,
            variantId,
            productTitle,
            variantTitle,
            sku,
            url,
            imageUrl,
          })),
        );
      }
    };

    const formatBasketMeta = () => {
      const template =
        productPicker?.dataset.metaLabel ||
        '{{ count }} of {{ maximum }} saved \u00b7 expires {{ date }}';
      const expires = new Date(Date.now() + storageDays * 24 * 60 * 60 * 1000);
      return template
        .replace(/%COUNT%|{{ count }}/g, String(basketItems.length))
        .replace(/%MAXIMUM%|{{ maximum }}/g, String(storageMaximum))
        .replace(/%DATE%|{{ date }}/g, formatLocalDate(expires));
    };

    const requestTypeLabel = (input) =>
      input?.closest('.reverie-swatches-choice')?.querySelector('span')?.textContent?.trim() ||
      input?.value ||
      '';

    const updateRequestType = () => {
      const checked = requestTypeInputs.find((input) => input.checked);
      setSummary('request', requestTypeLabel(checked));
      if (customRequest) {
        if (requestCustomInput?.checked) customRequest.setAttribute('data-highlight', '');
        else customRequest.removeAttribute('data-highlight');
      }
    };

    const summaryText = (name) =>
      root.querySelector(`[data-swatches-summary="${name}"]`)?.textContent?.trim() || '';

    const syncWizardReview = () => {
      if (!wizardReviewValues.length) return;
      const quantity = selectedText(root.querySelector('[name="contact[estimated_quantity]"]'));
      const timeline = selectedText(root.querySelector('[name="contact[target_timeline]"]'));
      const colours = root.querySelector('[name="contact[preferred_colours]"]')?.value?.trim() || '';
      const contactName = root.querySelector('[name="contact[name]"]')?.value?.trim() || '';
      const contactEmail = root.querySelector('[name="contact[email]"]')?.value?.trim() || '';
      const country = selectedText(root.querySelector('[name="contact[country]"]'));
      const whatsapp = root.querySelector('[name="contact[whatsapp]"]')?.value?.trim() || '';
      const message = root.querySelector('[name="contact[body]"]')?.value?.trim() || '';
      const permission = root.querySelector('[name="contact[contact_permission]"]')?.checked
        ? 'Consent confirmed'
        : '';
      const values = {
        request: summaryText('request'),
        use: summaryText('use'),
        fabrics: summaryText('fabrics'),
        details: [quantity, timeline, colours].filter(Boolean).join(' · '),
        contact: [contactName, contactEmail, country, whatsapp].filter(Boolean).join(' · '),
        message: [message, permission].filter(Boolean).join(' · '),
      };
      wizardReviewValues.forEach((target) => {
        target.textContent = values[target.dataset.swatchesWizardReviewValue] || target.dataset.emptyText || '';
      });
    };

    const buildExportText = () => {
      const date = formatLocalDate(new Date());
      const lines = [
        `MingSilk Fabric Inquiry List \u2014 ${date}`,
        '',
        ...checkedItems().map((item, index) => {
          const parts = [`${index + 1}. ${item.productTitle}`];
          if (item.variantTitle) parts.push(`Variant: ${item.variantTitle}`);
          if (item.sku) parts.push(`SKU: ${item.sku}`);
          if (item.url) parts.push(`Product URL: ${item.url}`);
          if (item.imageUrl) parts.push(`Image URL: ${item.imageUrl}`);
          return parts.join('\n');
        }),
      ];
      return lines.join('\n');
    };

    const buildCsv = () => {
      const header = ['Product', 'Variant', 'SKU', 'URL', 'Image URL', 'Added'];
      const rows = checkedItems().map((item) => [
        item.productTitle,
        item.variantTitle,
        item.sku,
        item.url,
        item.imageUrl,
        new Date(item.addedAt).toISOString(),
      ]);
      return (
        '\uFEFF' + [header, ...rows].map((row) => row.map(escapeCsvValue).join(',')).join('\r\n')
      );
    };

    const copyExport = async () => {
      const text = buildExportText();
      try {
        await navigator.clipboard.writeText(text);
        setProductStatus(productPicker?.dataset.copiedLabel || 'Inquiry list copied to your clipboard.');
      } catch (_error) {
        const textarea = document.createElement('textarea');
        textarea.value = text;
        textarea.style.position = 'fixed';
        textarea.style.opacity = '0';
        document.body.append(textarea);
        textarea.select();
        try {
          document.execCommand('copy');
          setProductStatus(productPicker?.dataset.copiedLabel || 'Inquiry list copied to your clipboard.');
        } catch (_copyError) {
          textarea.focus();
          textarea.select();
          setProductStatus('Select the text below and copy it manually.');
        }
        textarea.remove();
      }
    };

    const downloadCsv = () => {
      const blob = new Blob([buildCsv()], { type: 'text/csv;charset=utf-8;' });
      const url = URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = `mingsilk-inquiry-list-${formatLocalDate(new Date())}.csv`;
      document.body.append(link);
      link.click();
      link.remove();
      window.setTimeout(() => URL.revokeObjectURL(url), 1000);
      setProductStatus(productPicker?.dataset.csvLabel || 'Inquiry list CSV downloaded.');
    };

    const printExport = () => {
      if (!printBook) return;
      printBook.replaceChildren();
      const heading = document.createElement('h2');
      heading.textContent = 'MingSilk Fabric Inquiry List';
      printBook.append(heading);
      const date = document.createElement('p');
      date.textContent = formatLocalDate(new Date());
      printBook.append(date);
      checkedItems().forEach((item) => {
        const row = document.createElement('article');
        row.className = 'reverie-swatches-print-book__item';
        const image = createProductImage(item.imageUrl, '', 'reverie-swatches-print-book__image');
        if (image) row.append(image);
        const copy = document.createElement('div');
        copy.className = 'reverie-swatches-print-book__copy';
        const title = document.createElement('strong');
        title.textContent = item.productTitle;
        copy.append(title);
        const details = [item.variantTitle, item.sku ? `SKU ${item.sku}` : ''].filter(Boolean);
        if (details.length) {
          const meta = document.createElement('span');
          meta.textContent = details.join(' \u00b7 ');
          copy.append(meta);
        }
        if (item.url) {
          const link = document.createElement('a');
          link.href = item.url;
          link.textContent = item.url;
          copy.append(link);
        }
        row.append(copy);
        printBook.append(row);
      });
      setProductStatus(productPicker?.dataset.printLabel || 'Print preview opened.');
      window.print();
    };

    const panelUsesSheet = () => compactSummaryQuery.matches;
    const basketSheetIsOpen = () => basketSheet?.dataset.sheetOpen === 'true';

    const getFloatingBackdrop = () => {
      let backdrop = document.querySelector('[data-swatches-floating-backdrop]');
      if (backdrop) return backdrop;
      backdrop = document.createElement('div');
      backdrop.className = 'reverie-swatches-floating-backdrop';
      backdrop.dataset.swatchesFloatingBackdrop = '';
      backdrop.hidden = true;
      backdrop.addEventListener('click', () => closeBasketSheet());
      document.body.append(backdrop);
      return backdrop;
    };

    const basketSheetFocusables = () => {
      if (!basketSheet) return [];
      return Array.from(
        basketSheet.querySelectorAll(
          'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])',
        ),
      ).filter((element) => element.offsetParent !== null);
    };

    const syncBasketSheetState = (isOpen) => {
      if (!basketSheet || !floatingEntry) return;
      floatingEntry?.setAttribute('aria-expanded', String(isOpen));
      if (!isOpen) {
        delete basketSheet.dataset.sheetOpen;
        if (panelUsesSheet()) {
          basketSheet.setAttribute('aria-hidden', 'true');
          basketSheet.setAttribute('inert', '');
        } else {
          basketSheet.removeAttribute('aria-hidden');
          basketSheet.removeAttribute('inert');
        }
        const backdrop = document.querySelector('[data-swatches-floating-backdrop]');
        if (backdrop) {
          backdrop.hidden = true;
          delete backdrop.dataset.open;
        }
        document.body.classList.remove('reverie-swatches-scroll-lock');
        basketSheet.removeAttribute('role');
        basketSheet.removeAttribute('aria-modal');
        basketSheet.removeAttribute('aria-label');
        return;
      }
      basketSheet.dataset.sheetOpen = 'true';
      basketSheet.removeAttribute('aria-hidden');
      basketSheet.removeAttribute('inert');
      const backdrop = getFloatingBackdrop();
      backdrop.hidden = false;
      backdrop.dataset.open = 'true';
      document.body.classList.add('reverie-swatches-scroll-lock');
      basketSheet.setAttribute('role', 'dialog');
      basketSheet.setAttribute('aria-modal', 'true');
      const entryLabel = (floatingEntry.dataset.entryLabel || floatingEntry.textContent || 'Inquiry basket').trim();
      basketSheet.setAttribute('aria-label', `${entryLabel} (${basketItems.length})`);
      window.setTimeout(() => {
        const first = basketSheetClose || basketSheetFocusables()[0];
        if (first) first.focus();
      }, 0);
    };

    const closeBasketSheet = (returnFocus = true) => {
      if (!basketSheetIsOpen()) return;
      syncBasketSheetState(false);
      if (returnFocus) floatingEntry?.focus();
    };

    const toggleBasketSheet = () => {
      if (!panelUsesSheet()) return;
      if (basketSheetIsOpen()) closeBasketSheet();
      else syncBasketSheetState(true);
    };

    const renderBasketToolbar = () => {
      const selected = checkedItems().length;
      if (basketMeta) basketMeta.textContent = basketItems.length ? formatBasketMeta() : '';
      if (basketSelected) {
        basketSelected.textContent = selected
          ? `${selected} ${productPicker?.dataset.selectedSuffix || 'selected'}`
          : '';
      }
      if (selectAll) {
        selectAll.checked = basketItems.length > 0 && selected === basketItems.length;
        selectAll.indeterminate = selected > 0 && selected < basketItems.length;
        selectAll.disabled = basketItems.length === 0;
      }
      [exportCopy, exportCsv, exportPrint].forEach((button) => {
        if (button) button.disabled = selected === 0;
      });
      if (floatingCount) floatingCount.textContent = String(basketItems.length);
      if (floatingEntry) floatingEntry.hidden = false;
    };

    const update = () => {
      const selectedFabrics = fabricInputs.filter((input) => input.checked).map((input) => input.value);
      const selectedServices = serviceInputs.filter((input) => input.checked).map((input) => input.value);
      const selectedProducts = productSummary();
      const customRequestValue = customRequest?.value.trim() || '';
      const needsRecommendation = Boolean(unsureFabric?.checked || unsurePath?.checked);
      const unsureLabel = unsureFabric?.value || unsurePath?.value || 'Not sure yet';
      const selectedTotal = selectedFabrics.length + checkedItems().length;
      const selectedLabels = [...selectedFabrics, ...selectedProducts];

      if (customRequestValue) selectedLabels.push('Custom or unlisted fabric request');

      if (fabricOutput) {
        fabricOutput.value = selectedLabels.length
          ? selectedLabels.join(', ')
          : needsRecommendation
            ? unsureLabel
            : '';
      }
      if (serviceOutput) serviceOutput.value = selectedServices.join(', ');
      fabricCounts.forEach((count) => {
        count.textContent = `${selectedTotal} ${countSuffix}`.trim();
      });
      if (collectionCount) {
        collectionCount.textContent = `${selectedFabrics.length} ${collectionSuffix}`.trim();
      }

      setSummary(
        'fabrics',
        selectedLabels.length ? selectedLabels.join(', ') : needsRecommendation ? unsureLabel : '',
      );

      summarySources.forEach((source) => {
        setSummary(source.dataset.swatchesSummarySource, selectedText(source));
      });

      if (fabricError && (selectedLabels.length || needsRecommendation)) fabricError.hidden = true;
      updateRequestType();
      syncWizardReview();
    };

    const wizardStepByNumber = (number) =>
      wizardSteps.find((step) => Number.parseInt(step.dataset.swatchesWizardStep || '0', 10) === number);

    const formatWizardStatus = (number) => {
      const template = wizard?.dataset.stepStatusTemplate || 'Step %CURRENT% of %TOTAL%';
      return template
        .replace(/%CURRENT%/g, String(number))
        .replace(/%TOTAL%/g, String(wizardSteps.length));
    };

    const hasFabricSelection = () => {
      const hasFabric = fabricInputs.some((input) => input.checked);
      const hasProduct = checkedItems().length > 0;
      const hasCustomRequest = Boolean(customRequest?.value.trim());
      const needsRecommendation = Boolean(unsureFabric?.checked || unsurePath?.checked);
      return hasFabric || hasProduct || hasCustomRequest || needsRecommendation;
    };

    const validateWizardStep = (number, focusInvalid = false) => {
      const step = wizardStepByNumber(number);
      if (!step || number === wizardSteps.length) return true;
      const controls = Array.from(step.querySelectorAll('input, select, textarea'));
      const invalidControl = controls.find((control) => control.willValidate && !control.validity.valid);
      const fabricInvalid = number === FABRIC_STEP && !hasFabricSelection();
      const isValid = !invalidControl && !fabricInvalid;
      step.toggleAttribute('data-wizard-invalid', !isValid);

      if (!focusInvalid || isValid) return isValid;
      if (fabricInvalid) {
        if (fabricError) fabricError.hidden = false;
        (productSearch || fabricInputs[0] || customRequest || unsureFabric)?.focus({ preventScroll: true });
        return false;
      }
      invalidControl.setAttribute('aria-invalid', 'true');
      const enhanced = enhancedSelects.get(invalidControl);
      if (enhanced) {
        enhanced.trigger.setAttribute('aria-invalid', 'true');
        enhanced.trigger.focus({ preventScroll: true });
        return false;
      }
      invalidControl.focus({ preventScroll: true });
      invalidControl.reportValidity();
      return false;
    };

    const syncWizardProgress = () => {
      if (!wizard || !wizardSteps.length) return;
      const currentStep = wizardStepByNumber(currentWizardStep);
      const currentTitle = currentStep?.dataset.wizardTitle || '';
      const status = formatWizardStatus(currentWizardStep);
      if (wizardPosition) wizardPosition.textContent = status;
      if (wizardNavigationStatus) wizardNavigationStatus.textContent = status;
      if (wizardCurrentTitle) wizardCurrentTitle.textContent = currentTitle;
      if (wizardMeter) {
        const progress = `${(currentWizardStep / wizardSteps.length) * 100}%`;
        wizardMeter.style.setProperty('--reverie-swatches-wizard-progress', progress);
        wizardMeter.setAttribute('aria-valuenow', String(currentWizardStep));
        wizardMeter.setAttribute('aria-valuemax', String(wizardSteps.length));
      }
      if (wizard) {
        wizard.style.setProperty('--reverie-swatches-wizard-steps', String(wizardSteps.length));
        const progressNav = wizard.querySelector('.reverie-swatches-wizard__progress');
        progressNav?.style.setProperty('--reverie-swatches-wizard-steps', String(wizardSteps.length));
      }
      wizardProgressButtons.forEach((button) => {
        const target = Number.parseInt(button.dataset.swatchesWizardGo || '0', 10);
        const isCurrent = target === currentWizardStep;
        const isCompleted = target < highestWizardStep;
        button.disabled = target > highestWizardStep;
        button.toggleAttribute('data-completed', isCompleted);
        if (isCurrent) button.setAttribute('aria-current', 'step');
        else button.removeAttribute('aria-current');
      });
      if (wizardBack) wizardBack.hidden = currentWizardStep === 1;
      if (wizardNext) wizardNext.hidden = currentWizardStep === wizardSteps.length;
      syncWizardReview();
    };

    const focusWizardStep = (step) => {
      const heading = step?.querySelector('legend, [data-swatches-wizard-review-heading]');
      if (!heading) return;
      heading.setAttribute('tabindex', '-1');
      heading.focus({ preventScroll: true });
    };

    const showWizardStep = (number, focusStep = true) => {
      const nextStep = wizardStepByNumber(number);
      if (!wizard || !nextStep) return;
      if (number !== FABRIC_STEP && basketSheetIsOpen()) closeBasketSheet(false);
      const renderStep = () => {
        currentWizardStep = number;
        wizardSteps.forEach((step) => {
          const isCurrent = step === nextStep;
          step.hidden = !isCurrent;
          step.setAttribute('aria-hidden', String(!isCurrent));
        });
        root.dataset.wizardReady = 'true';
        syncWizardProgress();
      };
      const canTransition =
        root.dataset.wizardReady === 'true' &&
        typeof document.startViewTransition === 'function' &&
        !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const transition = canTransition ? document.startViewTransition(renderStep) : null;
      if (!transition) renderStep();
      if (!focusStep) return;
      const finish = transition?.finished || Promise.resolve();
      finish.finally(() => {
        if (window.matchMedia('(max-width: 989px)').matches) {
          wizard.scrollIntoView({
            behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
            block: 'start',
          });
          window.setTimeout(() => focusWizardStep(nextStep), 260);
        } else {
          focusWizardStep(nextStep);
        }
        if (wizardLive) wizardLive.textContent = `${formatWizardStatus(number)}: ${nextStep.dataset.wizardTitle || ''}`;
      });
    };

    const firstInvalidWizardStep = (lastStep) => {
      for (let number = 1; number <= lastStep; number += 1) {
        if (!validateWizardStep(number)) return number;
      }
      return 0;
    };

    const goToNextWizardStep = () => {
      update();
      const invalidStep = firstInvalidWizardStep(currentWizardStep);
      if (invalidStep) {
        showWizardStep(invalidStep, invalidStep !== currentWizardStep);
        window.setTimeout(() => validateWizardStep(invalidStep, true), 280);
        return;
      }
      highestWizardStep = Math.max(highestWizardStep, currentWizardStep + 1);
      showWizardStep(Math.min(currentWizardStep + 1, wizardSteps.length));
    };

    const initializeWizard = () => {
      if (!wizard || wizardSteps.length < 2) return;
      form.noValidate = true;
      if (restoreCheckedFromPending) {
        currentWizardStep = CONTACT_STEP;
        highestWizardStep = CONTACT_STEP;
      }
      wizardGoButtons.forEach((button) => {
        button.addEventListener('click', () => {
          const target = Number.parseInt(button.dataset.swatchesWizardGo || '0', 10);
          if (!target || target > highestWizardStep) return;
          showWizardStep(target);
        });
      });
      wizardBack?.addEventListener('click', () => showWizardStep(Math.max(1, currentWizardStep - 1)));
      wizardNext?.addEventListener('click', goToNextWizardStep);
      form.addEventListener('input', (event) => {
        event.target?.removeAttribute?.('aria-invalid');
        syncWizardReview();
      });
      form.addEventListener('change', () => {
        syncWizardReview();
        const step = wizardStepByNumber(currentWizardStep);
        if (step && validateWizardStep(currentWizardStep)) step.removeAttribute('data-wizard-invalid');
      });
      form.addEventListener('keydown', (event) => {
        if (event.defaultPrevented || event.key !== 'Enter' || currentWizardStep >= wizardSteps.length) return;
        const target = event.target;
        if (
          target instanceof HTMLTextAreaElement ||
          target === productSearch ||
          target instanceof HTMLButtonElement ||
          target?.matches?.('input[type="checkbox"], input[type="radio"]')
        ) {
          return;
        }
        event.preventDefault();
        goToNextWizardStep();
      });
      showWizardStep(currentWizardStep, false);
    };

    const createProductImage = (source, alt, className) => {
      if (!source) return null;
      const image = document.createElement('img');
      image.className = className;
      image.src = source;
      image.alt = alt;
      image.loading = 'lazy';
      image.addEventListener('error', () => image.remove());
      return image;
    };

    const renderBasket = () => {
      if (!productList) return;
      productList.replaceChildren();

      basketItems.forEach((item) => {
        const row = document.createElement('li');
        row.className = 'reverie-swatches-inquiry-basket__item';
        const key = itemKey(item);

        const checkLabel = document.createElement('label');
        checkLabel.className = 'reverie-swatches-basket-check-item';
        const checkbox = document.createElement('input');
        checkbox.type = 'checkbox';
        checkbox.className = 'reverie-swatches-basket-item-check';
        checkbox.dataset.swatchesBasketItem = '';
        checkbox.checked = selectedKeys.has(key);
        checkbox.setAttribute('aria-label', `Select ${item.productTitle}`);
        checkbox.addEventListener('change', () => {
          if (checkbox.checked) selectedKeys.add(key);
          else selectedKeys.delete(key);
          renderBasketToolbar();
          update();
        });
        checkLabel.append(checkbox);

        const media = document.createElement('span');
        media.className = 'reverie-swatches-inquiry-basket__media';
        const image = createProductImage(item.imageUrl, '', 'reverie-swatches-inquiry-basket__image');
        if (image) media.append(image);

        const copy = document.createElement('span');
        copy.className = 'reverie-swatches-inquiry-basket__copy';
        const title = document.createElement('strong');
        title.textContent = item.productTitle;
        copy.append(title);

        const details = [item.variantTitle, item.sku ? `SKU ${item.sku}` : ''].filter(Boolean);
        if (details.length) {
          const meta = document.createElement('small');
          meta.textContent = details.join(' · ');
          copy.append(meta);
        }

        if (item.url) {
          const link = document.createElement('a');
          link.href = item.url;
          link.textContent = 'View product';
          copy.append(link);
        }

        const remove = document.createElement('button');
        remove.type = 'button';
        remove.className = 'reverie-swatches-inquiry-basket__remove';
        remove.textContent = '\u00d7';
        remove.setAttribute(
          'aria-label',
          `${productPicker?.dataset.removeLabel || 'Remove'} ${item.productTitle}`,
        );
        remove.addEventListener('click', () => {
          basketItems = basketItems.filter((candidate) => itemKey(candidate) !== key);
          selectedKeys.delete(key);
          persistBasket();
          renderBasket();
          if (basketStatus) {
            basketStatus.textContent = `Removed ${item.productTitle}`;
          }
        });

        row.append(checkLabel, media, copy, remove);
        productList.append(row);
      });

      if (productEmpty) productEmpty.hidden = basketItems.length > 0;
      productList.hidden = basketItems.length === 0;
      if (productCount) productCount.textContent = String(basketItems.length);
      if (productClear) productClear.disabled = basketItems.length === 0;
      renderBasketToolbar();
      syncProductOutputs();
      update();
    };

    const addProduct = (product, variant, fallbackImage, fallbackUrl) => {
      const item = productItem(product, variant, fallbackImage, fallbackUrl);
      if (!item) {
        setProductStatus(productPicker?.dataset.searchError);
        return;
      }

      if (basketItems.some((candidate) => itemKey(candidate) === itemKey(item))) {
        setProductStatus(productPicker?.dataset.addedLabel);
        return;
      }
      if (basketItems.length >= storageMaximum) {
        setProductStatus(productPicker?.dataset.limitMessage);
        return;
      }

      basketItems = [...basketItems, item];
      selectedKeys.add(itemKey(item));
      if (unsureFabric) unsureFabric.checked = false;
      if (unsurePath?.checked) {
        const fabricPath = pathInputs.find((input) => input !== unsurePath);
        if (fabricPath) fabricPath.checked = true;
      }
      persistBasket();
      renderBasket();
      setProductStatus(productPicker?.dataset.addedLabel);
    };

    const renderVariantControls = (card, product, fallbackImage, fallbackUrl) => {
      const existing = card.querySelector('.reverie-swatches-product-result__controls');
      if (existing) existing.remove();

      const controls = document.createElement('div');
      controls.className = 'reverie-swatches-product-result__controls';
      const variants = Array.isArray(product.variants) ? product.variants : [];
      if (!variants.length) {
        setProductStatus(productPicker?.dataset.searchError);
        return;
      }

      let selector;
      if (variants.length > 1) {
        selector = document.createElement('select');
        selector.setAttribute('aria-label', 'Product option');
        variants.forEach((variant, index) => {
          const option = document.createElement('option');
          option.value = String(index);
          option.textContent = [variant.title, variant.sku ? `SKU ${variant.sku}` : ''].filter(Boolean).join(' — ');
          selector.append(option);
        });
        controls.append(selector);
      }

      const add = document.createElement('button');
      add.type = 'button';
      add.textContent = productPicker?.dataset.addLabel || 'Add to inquiry';
      add.addEventListener('click', () => {
        const variant = variants[Number.parseInt(selector?.value || '0', 10)] || variants[0];
        addProduct(product, variant, fallbackImage, fallbackUrl);
      });
      controls.append(add);
      card.append(controls);
      selector?.focus();
    };

    const renderSearchResults = (products) => {
      if (!productResults) return;
      productResults.replaceChildren();
      productResults.hidden = products.length === 0;

      if (!products.length) {
        setProductStatus('No matching fabrics found. Try a broader search or describe your request below.');
        return;
      }

      products.forEach((product) => {
        const card = document.createElement('article');
        card.className = 'reverie-swatches-product-result';
        card.setAttribute('role', 'listitem');
        const resultImage = imageUrl(product.image || product.featured_image);

        const media = document.createElement('span');
        media.className = 'reverie-swatches-product-result__media';
        const image = createProductImage(resultImage, '', 'reverie-swatches-product-result__image');
        if (image) media.append(image);

        const copy = document.createElement('span');
        copy.className = 'reverie-swatches-product-result__copy';
        const title = document.createElement('strong');
        title.textContent = textValue(product.title, 240);
        copy.append(title);

        const choose = document.createElement('button');
        choose.type = 'button';
        choose.textContent = productPicker?.dataset.chooseLabel || 'Choose option';
        choose.addEventListener('click', async () => {
          choose.disabled = true;
          choose.setAttribute('aria-busy', 'true');
          try {
            const fullProduct = await fetchProductData(product.url);
            choose.remove();
            renderVariantControls(card, fullProduct, resultImage, product.url);
          } catch (_error) {
            choose.disabled = false;
            choose.removeAttribute('aria-busy');
            setProductStatus(productPicker?.dataset.searchError);
          }
        });
        copy.append(choose);
        card.append(media, copy);
        productResults.append(card);
      });
    };

    const searchProducts = async () => {
      if (!productPicker || !productSearch || !productResults) return;
      const query = productSearch.value.trim();
      const minimum = Number.parseInt(productPicker.dataset.searchMinimum || '2', 10);
      if (query.length < minimum) {
        productResults.replaceChildren();
        productResults.hidden = true;
        setProductStatus(productPicker.dataset.searchEmpty);
        return;
      }

      activeSearch?.abort();
      activeSearch = new AbortController();
      productSearchButton?.setAttribute('aria-busy', 'true');
      if (productSearchButton) productSearchButton.disabled = true;
      setProductStatus(productPicker.dataset.searchLoading);

      try {
        const url = new URL(productPicker.dataset.searchUrl, window.location.origin);
        url.searchParams.set('q', query);
        url.searchParams.set('resources[type]', 'product');
        url.searchParams.set('resources[limit]', '8');
        url.searchParams.set('resources[options][unavailable_products]', 'last');
        const response = await fetch(url.href, {
          headers: { Accept: 'application/json' },
          signal: activeSearch.signal,
        });
        if (!response.ok) throw new Error('Search request failed');
        const data = await response.json();
        const products = data?.resources?.results?.products || [];
        renderSearchResults(products);
        if (products.length) setProductStatus(`${products.length} matching products`);
      } catch (error) {
        if (error.name !== 'AbortError') {
          productResults.replaceChildren();
          productResults.hidden = true;
          setProductStatus(productPicker.dataset.searchError);
        }
      } finally {
        productSearchButton?.removeAttribute('aria-busy');
        if (productSearchButton) productSearchButton.disabled = false;
      }
    };

    fabricInputs.forEach((input) => {
      input.addEventListener('change', () => {
        if (input.checked && unsureFabric) unsureFabric.checked = false;
        update();
      });
    });

    serviceInputs.forEach((input) => input.addEventListener('change', update));
    summarySources.forEach((source) => {
      source.addEventListener('change', update);
      source.addEventListener('input', update);
    });
    customRequest?.addEventListener('input', update);

    pathInputs.forEach((input) => {
      input.addEventListener('change', () => {
        if (input === unsurePath && input.checked) {
          fabricInputs.forEach((fabric) => {
            fabric.checked = false;
          });
          if (unsureFabric) unsureFabric.checked = true;
        } else if (input.checked && unsureFabric) {
          unsureFabric.checked = false;
        }
        update();
      });
    });

    unsureFabric?.addEventListener('change', () => {
      if (unsureFabric.checked) {
        fabricInputs.forEach((input) => {
          input.checked = false;
        });
      }
      update();
    });

    clearButton?.addEventListener('click', () => {
      fabricInputs.forEach((input) => {
        input.checked = false;
      });
      if (unsureFabric) unsureFabric.checked = false;
      update();
    });

    requestTypeInputs.forEach((input) => {
      input.addEventListener('change', () => {
        updateRequestType();
        if (input === requestCustomInput && input.checked && customRequest) {
          customRequest.scrollIntoView({ behavior: 'smooth', block: 'center' });
          window.setTimeout(() => {
            customRequest.querySelector('textarea, input, select')?.focus({ preventScroll: true });
          }, 400);
        }
      });
    });

    selectAll?.addEventListener('change', () => {
      basketItems.forEach((item) => {
        const key = itemKey(item);
        if (selectAll.checked) selectedKeys.add(key);
        else selectedKeys.delete(key);
      });
      productList?.querySelectorAll('[data-swatches-basket-item]').forEach((checkbox) => {
        checkbox.checked = selectAll.checked;
      });
      renderBasketToolbar();
      update();
    });

    exportCopy?.addEventListener('click', copyExport);
    exportCsv?.addEventListener('click', downloadCsv);
    exportPrint?.addEventListener('click', printExport);

    if (floatingEntry) {
      floatingEntry.addEventListener('click', () => {
        if (wizard && currentWizardStep !== FABRIC_STEP) {
          highestWizardStep = Math.max(highestWizardStep, FABRIC_STEP);
          showWizardStep(FABRIC_STEP);
          window.setTimeout(toggleBasketSheet, 320);
          return;
        }
        toggleBasketSheet();
      });
      basketSheetClose?.addEventListener('click', () => closeBasketSheet());
      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && basketSheetIsOpen()) {
          event.preventDefault();
          closeBasketSheet();
          return;
        }
        if (event.key === 'Tab' && basketSheetIsOpen()) {
          const focusables = basketSheetFocusables();
          if (!focusables.length) return;
          const first = focusables[0];
          const last = focusables[focusables.length - 1];
          if (event.shiftKey && document.activeElement === first) {
            event.preventDefault();
            last.focus();
          } else if (!event.shiftKey && document.activeElement === last) {
            event.preventDefault();
            first.focus();
          }
        }
      });
      if (typeof IntersectionObserver === 'function') {
        const footerElement = document.querySelector('footer');
        if (footerElement) {
          const footerObserver = new IntersectionObserver(
            (entries) => {
              entries.forEach((entry) => {
                floatingEntry.classList.toggle(
                  'reverie-swatches-floating-entry--hide',
                  entry.isIntersecting,
                );
              });
            },
            { rootMargin: '0px 0px -15% 0px' },
          );
          footerObserver.observe(footerElement);
        }
      }
      const closeSheetOutsideMobile = (event) => {
        if (!event.matches && basketSheetIsOpen()) closeBasketSheet(false);
        else if (!basketSheetIsOpen()) syncBasketSheetState(false);
      };
      if (compactSummaryQuery.addEventListener) {
        compactSummaryQuery.addEventListener('change', closeSheetOutsideMobile);
      } else {
        compactSummaryQuery.addListener(closeSheetOutsideMobile);
      }
    }

    productSearchButton?.addEventListener('click', searchProducts);
    productSearch?.addEventListener('keydown', (event) => {
      if (event.key !== 'Enter') return;
      event.preventDefault();
      window.clearTimeout(searchTimer);
      searchProducts();
    });
    productSearch?.addEventListener('input', () => {
      window.clearTimeout(searchTimer);
      searchTimer = window.setTimeout(searchProducts, 350);
    });
    productClear?.addEventListener('click', () => {
      basketItems = [];
      selectedKeys.clear();
      persistBasket();
      renderBasket();
      setProductStatus(productPicker?.dataset.basketEmpty);
    });

    form.addEventListener('submit', (event) => {
      update();
      syncProductOutputs();
      if (wizard) {
        const invalidStep = firstInvalidWizardStep(wizardSteps.length - 1);
        if (invalidStep) {
          event.preventDefault();
          highestWizardStep = Math.max(highestWizardStep, invalidStep);
          showWizardStep(invalidStep);
          window.setTimeout(() => validateWizardStep(invalidStep, true), 280);
          return;
        }
      }
      const hasFabric = fabricInputs.some((input) => input.checked);
      const hasProduct = checkedItems().length > 0;
      const hasCustomRequest = Boolean(customRequest?.value.trim());
      const needsRecommendation = Boolean(unsureFabric?.checked || unsurePath?.checked);
      if (!hasFabric && !hasProduct && !hasCustomRequest && !needsRecommendation) {
        event.preventDefault();
        if (fabricError) fabricError.hidden = false;
        (productSearch || fabricInputs[0] || customRequest || unsureFabric)?.focus();
        return;
      }
      if (hasProduct) {
        writePendingRemoval(checkedItems().map(itemKey));
      } else {
        clearPendingRemoval();
      }
    });

    window.addEventListener('storage', (event) => {
      if (event.key !== STORAGE_KEY) return;
      basketItems = readBasket();
      selectedKeys = new Set(basketItems.map(itemKey));
      renderBasket();
    });

    basketItems = readBasket();
    if (successRemaining) {
      const pending = readPendingRemoval();
      const pendingSet = new Set(pending);
      if (pendingSet.size) {
        const before = basketItems.length;
        basketItems = basketItems.filter((item) => !pendingSet.has(itemKey(item)));
        if (basketItems.length !== before) persistBasket();
        clearPendingRemoval();
      }
      const remaining = basketItems.length;
      const remainingLabel =
        successRemaining.dataset.remainingLabel || 'Remaining in your inquiry basket: {{ count }}';
      if (remaining > 0) {
        successRemaining.textContent = remainingLabel.replace(/%COUNT%|\{\{\s*count\s*\}\}/g, String(remaining));
        successRemaining.hidden = false;
      }
    } else {
      const pending = restoreCheckedFromPending ? new Set(readPendingRemoval()) : null;
      selectedKeys = new Set(
        basketItems.map(itemKey).filter((key) => (pending ? pending.has(key) : true)),
      );
    }
    if (productPicker) productPicker.hidden = false;
    initializePickers();
    renderBasket();
    syncBasketSheetState(false);
    initializeWizard();

    if (new URLSearchParams(window.location.search).get('basket') === '1') {
      if (wizard) {
        highestWizardStep = Math.max(highestWizardStep, FABRIC_STEP);
        showWizardStep(FABRIC_STEP, false);
      }
      window.setTimeout(() => {
        if (panelUsesSheet()) syncBasketSheetState(true);
        else basketSheet?.scrollIntoView({ block: 'start' });
      }, 120);
    }
  };

  const initializeFabricInquiryDial = (root) => {
    if (root.dataset.reverieDialReady === 'true') return;

    const select = root.querySelector('[data-reverie-inquiry-country-select]');
    const phone = root.querySelector('[data-reverie-inquiry-phone]');
    const trigger = root.querySelector('[data-reverie-inquiry-dial-trigger]');
    const flag = root.querySelector('[data-reverie-inquiry-dial-flag]');
    const dial = root.querySelector('[data-reverie-inquiry-dial-code]');
    const hint = root.querySelector('[data-reverie-inquiry-dial-hint]');
    const dialog = root.querySelector('[data-reverie-inquiry-country-dialog]');
    const close = root.querySelector('[data-reverie-inquiry-country-close]');
    const search = root.querySelector('[data-reverie-inquiry-country-search]');
    const list = root.querySelector('[data-reverie-inquiry-country-list]');
    const empty = root.querySelector('[data-reverie-inquiry-country-empty]');
    if (!select || !phone || !trigger || !dialog || !search || !list) return;

    const items = Array.from(select.options)
      .filter((option) => option.value && option.value !== '---' && option.textContent.trim() !== '---')
      .map((option) => ({ option, ...countryMetaForName(option.textContent.trim()) }))
      .filter((item) => item.dial);
    let lastDialCode = '';

    const setTrigger = (item = {}) => {
      if (flag) {
        flag.textContent = item.flag || '🌐';
      }
      if (dial) dial.textContent = item.dial || '+';
      trigger.setAttribute(
        'aria-label',
        item.name ? `WhatsApp country code: ${item.name} ${item.dial}` : 'Select WhatsApp country code',
      );
      if (hint) {
        hint.textContent = item.name ? `${item.flag || ''} ${item.name} · ${item.dial}`.trim() : '';
        hint.hidden = !item.name;
      }
    };

    const applyItem = (item) => {
      const current = phone.value.trim();
      const previous = lastDialCode || detectDialCodeIn(current);
      if (!current) {
        phone.value = `${item.dial} `;
      } else if (previous && current.startsWith(previous)) {
        const localNumber = current.slice(previous.length).trim();
        phone.value = localNumber ? `${item.dial} ${localNumber}` : `${item.dial} `;
      } else if (!current.startsWith('+')) {
        phone.value = `${item.dial} ${current}`;
      }
      lastDialCode = item.dial;
      select.value = item.option.value;
      select.dispatchEvent(new Event('change', { bubbles: true }));
      phone.dispatchEvent(new Event('input', { bubbles: true }));
      setTrigger(item);
      dialog.close();
      window.setTimeout(() => phone.focus({ preventScroll: true }), 0);
    };

    const optionButtons = items.map((item) => {
      const button = document.createElement('button');
      const optionFlag = document.createElement('span');
      const optionName = document.createElement('span');
      const optionDial = document.createElement('span');
      button.type = 'button';
      button.className = 'reverie-fabric-inquiry__country-option';
      button.dataset.search = normalizeCountryKey(`${item.name} ${item.iso} ${item.dial}`);
      optionFlag.className = 'reverie-fabric-inquiry__country-option-flag';
      optionFlag.textContent = item.flag || '🌐';
      optionFlag.setAttribute('aria-hidden', 'true');
      optionName.className = 'reverie-fabric-inquiry__country-option-name';
      optionName.textContent = item.name;
      optionDial.className = 'reverie-fabric-inquiry__country-option-dial';
      optionDial.textContent = item.dial;
      button.append(optionFlag, optionName, optionDial);
      button.addEventListener('click', () => applyItem(item));
      list.append(button);
      return button;
    });

    const filterOptions = () => {
      const query = normalizeCountryKey(search.value);
      let visible = 0;
      optionButtons.forEach((button) => {
        const matches = !query || button.dataset.search.includes(query);
        button.hidden = !matches;
        if (matches) visible += 1;
      });
      if (empty) empty.hidden = visible !== 0;
    };

    const openDialog = () => {
      if (typeof dialog.showModal !== 'function') {
        select.hidden = false;
        select.focus();
        return;
      }
      trigger.setAttribute('aria-expanded', 'true');
      search.value = '';
      filterOptions();
      document.body.classList.add('reverie-fabric-inquiry-picker-open');
      dialog.showModal();
      window.setTimeout(() => search.focus(), 0);
    };

    trigger.addEventListener('click', openDialog);
    close?.addEventListener('click', () => dialog.close());
    search.addEventListener('input', filterOptions);
    dialog.addEventListener('click', (event) => {
      if (event.target === dialog) dialog.close();
    });
    dialog.addEventListener('close', () => {
      trigger.setAttribute('aria-expanded', 'false');
      document.body.classList.remove('reverie-fabric-inquiry-picker-open');
      trigger.focus({ preventScroll: true });
    });

    const selectedOption = select.options[select.selectedIndex];
    if (selectedOption?.value) {
      const selectedItem = items.find((item) => item.option === selectedOption);
      if (selectedItem) {
        lastDialCode = selectedItem.dial;
        setTrigger(selectedItem);
      }
    } else {
      setTrigger();
    }
    root.dataset.reverieDialReady = 'true';
  };

  const initializeAll = (scope = document) => {
    scope.querySelectorAll('[data-swatches-workbench]').forEach(initializeWorkbench);
    scope.querySelectorAll('[data-reverie-inquiry-add]').forEach(initializeInquiryAddButton);
    scope.querySelectorAll('[data-reverie-fabric-inquiry]').forEach(initializeFabricInquiryDial);
  };

  document.addEventListener('reverie:inquiry-basket-change', () => {
    document.querySelectorAll('[data-reverie-inquiry-add]').forEach(refreshInquiryButtonState);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initializeAll());
  } else {
    initializeAll();
  }

  document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
})();
